import { Thumbnail } from '../../../Thumbnail/Thumbnail';

import type { FC } from 'react';

import styles from './Category.module.scss';

type Props = {
  category: {
    additional?: { image?: string | null } | Record<string, unknown>;
    title?: string;
  };
  className?: string;
};

const Category: FC<Props> = ({ category, className }) => {
  return (
    <div className={className}>
      <Thumbnail
        url={`${(category.additional as { image?: string | null }).image}?t[]=161x91q80`}
        alt={category.title}
      />
      <div className={styles.title}>{category.title}</div>
    </div>
  );
};

export { Category };
